import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ConversionConfiguration } from 'src/app/model/conversion-configuration';
import { ConversionConfigurationService } from 'src/oldApp/services/conversion-configuration.service';
import { CreatorService } from 'src/app/services/creator.service';
import { ModalConversionConfigurationComponent } from 'src/oldApp/shared/modal-conversion-configuration/modal-conversion-configuration.component';

@Component({
  selector: 'app-conversion-configuration',
  templateUrl: './conversion-configuration.component.html',
  styleUrls: ['./conversion-configuration.component.css']
})
export class ConversionConfigurationComponent implements OnInit {
  // estado pagina
  public page:string='ConversionConfiguration';
  public viewStatus=0;  // -1:nada, 0:spinner, 1:tabla
  public listConversionConfig:ConversionConfiguration[]=[];

  // opciones datatables
  dtOptions={
    order:[],
    responsive:true,
    columnDefs: [
      { responsivePriority: 1, width:100, targets: -1 }
    ],
    select: 'single',
    bLengthChange: true,
    searching :true,
    dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    // dom: 'Bfrtip',
    autoWidth:false,
    // pagingType: 'full_numbers',
    paging:true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  constructor(
    private conversionConfigurationService:ConversionConfigurationService,
    private creator:CreatorService,
    private modalService:NgbModal,
    private toastr:ToastrService
  ) { }

  ngOnInit() {
    this.getCatalogs();
  }

  //
  add=()=> {
    let conversionConfig=this.creator.newConversionConfiguration();
    conversionConfig.noCreditsFrom=null;
    conversionConfig.noCreditsTo=null;
    conversionConfig.description='';
    let modalRef=this.modalService.open(ModalConversionConfigurationComponent, {centered:true, size:'lg', scrollable:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.conversionConfig=conversionConfig;
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='create';
    modalRef.componentInstance.listConversionConfig=this.listConversionConfig;
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }
  edit=(conversionConfig:ConversionConfiguration)=> {
    let modalRef=this.modalService.open(ModalConversionConfigurationComponent, {centered:true, size:'lg', scrollable:true, backdrop:true, keyboard:false});
    modalRef.componentInstance.conversionConfig={...conversionConfig};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='edit';
    modalRef.componentInstance.listConversionConfig=this.listConversionConfig;
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }
  detail=(conversionConfig:ConversionConfiguration)=> {
    let modalRef=this.modalService.open(ModalConversionConfigurationComponent, {centered:true, size:'lg', scrollable:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.conversionConfig={...conversionConfig};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='detail';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }
  delete=(conversionConfig:ConversionConfiguration)=> {
    let modalRef=this.modalService.open(ModalConversionConfigurationComponent, {centered:true, size:'lg', scrollable:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.conversionConfig={...conversionConfig};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='delete';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }
  toggleActive=(conversionConfig:ConversionConfiguration)=> {
    let modalRef=this.modalService.open(ModalConversionConfigurationComponent, {centered:true, size:'lg', scrollable:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.conversionConfig={...conversionConfig};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='toggleActive';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }

  // INFO
  getCatalogs=()=> {
    forkJoin(
      this.conversionConfigurationService.getList(),
    )
    .pipe(
      tap(([conversionConfigResp]:[any])=> {
        if(conversionConfigResp) {
          this.listConversionConfig=conversionConfigResp.data;
          this.viewStatus=1;
        }
        else throwError;
      }),
      catchError(error=> {
        console.log(error);
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al obtener la información'));
      })
    )
    .subscribe();
  }

}
